import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { translate } from './translateFunction';

const Register = () => {
  const [vorname, setVorname] = useState('');
  const [nachname, setNachname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const [translations, setTranslations] = useState({
    registerTitle: '',
    firstNameLabel: '',
    lastNameLabel: '',
    emailLabel: '',
    passwordLabel: '',
    confirmPasswordLabel: '',
    registerButton: '',
    alreadyRegisteredLink: '',
    passwordMismatchMessage: '',
    registrationSuccessMessage: '',
    registrationFailedMessage: '',
    tryAgainMessage: '',
    successMessage: '',
    successMessagetwo: '',
  });

  useEffect(() => {
    const loadTranslations = async () => {
      const registerTitle = await translate(160);
      const firstNameLabel = await translate(161);
      const lastNameLabel = await translate(162);
      const emailLabel = await translate(163);
      const passwordLabel = await translate(164);
      const confirmPasswordLabel = await translate(165);
      const registerButton = await translate(166);
      const alreadyRegisteredLink = await translate(167);
      const passwordMismatchMessage = await translate(168);
      const registrationSuccessMessage = await translate(169);
      const registrationFailedMessage = await translate(170);
      const tryAgainMessage = await translate(171);
      const successMessage = await translate(169);
      const successMessagetwo = await translate(420);

      setTranslations({
        registerTitle,
        firstNameLabel,
        lastNameLabel,
        emailLabel,
        passwordLabel,
        confirmPasswordLabel,
        registerButton,
        alreadyRegisteredLink,
        passwordMismatchMessage,
        registrationSuccessMessage,
        registrationFailedMessage,
        tryAgainMessage,
        successMessage,
        successMessagetwo,
      });
    };

    loadTranslations();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      setMessage(translations.passwordMismatchMessage);
      setError(true);
      return;
    }

    try {
      const response = await fetch('/api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ vorname, nachname, email, password }),
      });

      if (response.ok) {
        // Benachrichtigung an den Admin und Bestätigungsmail verschickt der Server bei der Registrierung
        setSubmitted(true);
        setError(false);

        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setMessage(translations.registrationFailedMessage);
        setError(true);
      }
    } catch (error) {
      setMessage(translations.tryAgainMessage);
      setError(true);
    }
  };

  return (
    <div className="container mt-5">
      {!submitted ? (
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <h1 className="card-title">{translations.registerTitle}</h1>
                {message && (
                  <div className={`alert ${error ? 'alert-danger' : 'alert-success'}`}>
                    {message}
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="vorname">{translations.firstNameLabel}</label>
                    <input
                      type="text"
                      className="form-control"
                      id="vorname"
                      value={vorname}
                      onChange={(e) => setVorname(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="nachname">{translations.lastNameLabel}</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nachname"
                      value={nachname}
                      onChange={(e) => setNachname(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">{translations.emailLabel}</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">{translations.passwordLabel}</label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirmPassword">{translations.confirmPasswordLabel}</label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    {translations.registerButton}
                  </button>
                </form>
                <div className="mt-3">
                  <Link to="/login">{translations.alreadyRegisteredLink}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="feedback-success-message" style={{ textAlign: 'center' }}>
          <div className="checkmark">&#10003;</div>
          <h3>
            {translations.successMessage}
            <br />
            {translations.successMessagetwo}
          </h3>
        </div>
      )}
    </div>
  );
};

export default Register;
